<template>
  <div
    class="index-container all-box"
    v-loading="isLoading"
    ref="mainContainer"
  >
    <svg class="svg-clip-path">
      <clipPath id="bannerCurvedBottom" clipPathUnits="objectBoundingBox">
        <path d="M0,0 L0,0.94 C0.25,1.05 0.94,1.05 1,0.94 L1,0 Z" />
      </clipPath>
    </svg>
    <div class="banner-container" ref="carouselContainer">
      <el-carousel
        height="auto"
        :autoplay="true"
        :interval="5000"
        :loop="true"
        arrow="never"
        ref="carousel"
      >
        <el-carousel-item
          v-for="(item, index) in datas.bannerList"
          :key="index"
        >
          <component
            :is="getLinkType(item)"
            v-bind="getLinkProps(item)"
            class="banner-link"
          >
            <el-image
              :src="item.thumb"
              class="banner-img"
              fit="cover"
              :alt="item.title"
              @load="handleImageLoad"
            >
              <template #placeholder>
                <div class="image-slot">加载中...</div>
              </template>
              <template #error>
                <div class="image-slot image-error-slot">
                  <img
                    :src="require('@/assets/author.png')"
                    alt="图片加载失败"
                  />
                </div>
              </template>
            </el-image>
          </component>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="index-wrapper">
      <div class="index-btn-container">
        <div class="btn-left-container">
          <component
            :is="getLinkType(itemViews[2])"
            v-bind="getLinkProps(itemViews[2])"
            class="btn-item"
          >
            <img src="@/assets/jihuo.png" alt="激活" />
          </component>
        </div>

        <div class="btn-right-container">
          <component
            :is="getLinkType(itemViews[0])"
            v-bind="getLinkProps(itemViews[0])"
            class="btn-item"
          >
            <img src="@/assets/activebtn.png" alt="活动按钮" />
          </component>
          <component
            :is="getLinkType(itemViews[1])"
            v-bind="getLinkProps(itemViews[1])"
            class="btn-item"
          >
            <img src="@/assets/choujiang.png" alt="抽奖按钮" />
          </component>
        </div>
      </div>
    </div>
    <div class="list-container">
      <div class="list-title">
        <el-text tag="b" size="large">活动列表</el-text>
      </div>
      <ActiveList :list="datas.records" v-if="datas.records.total !== 0" />
      <div
        class="loading"
        element-loading-text="加载中..."
        v-loading="isLoading"
        v-if="!isNotMore"
        :style="{ paddingTop: datas.records.total !== 0 ? 0 : '150px' }"
      ></div>
      <div class="noMore" v-if="isNotMore">更多活动，敬请期待</div>
    </div>
  </div>
</template>

<script>
import fetchData from "@/mixins/fetchData.js";
import mainScroll from "@/mixins/mainScroll.js";
import { getActives } from "@/api/active.js";
import { getHomeBanner } from "@/api/home.js";
import ActiveList from "@/views/Active/components/ActiveList";
import Footer from "@/components/util/Footer";
import KyIcon from "@/components/KyIcon";

export default {
  components: {
    Footer,
    KyIcon,
    ActiveList,
  },
  mixins: [
    fetchData({
      records: { total: 0, data: [] },
      bannerList: [],
    }),
    mainScroll("mainContainer"),
  ],
  created() {
    this.$bus.$on("mainScroll", this.handleScroll);
  },
  mounted() {
    this.initTouchEvent();
  },
  unmounted() {
    this.$bus.$off("mainScroll", this.handleScroll);
  },
  data() {
    return {
      page: 1,
      limit: 10,
      isNotMore: false,
      storage: window.localStorage,
      carousel: null,
      carouselContainer: null,
      itemViews: [
        {
          title: "活动中心",
          link_url: "Active",
          link_type: "internal",
        },
        {
          title: "幸运抽奖",
          link_url: "LuckDraw",
          link_type: "internal",
        },
        {
          title: "激活订阅",
          link_url: "https://sale.xinmin.cn/wanbaodingyue/index.html",
          link_type: "external",
        },
      ],
      startX: 0,
      minSwipeDistance: 50,
    };
  },
  methods: {
    async fetchData() {
      const [activeResp, bannerResp] = await Promise.all([
        getActives(this.page, this.limit),
        getHomeBanner(),
      ]);
      return {
        records: activeResp.records || { total: 0, data: [] },
        bannerList: bannerResp.records.data || [],
      };
    },
    handleImageLoad() {
      if (!this.$refs.carousel) return;

      const carousel = this.$refs.carousel;
      const total = this.datas.bannerList.length;
      if (total === 0) return;

      let currentIndex = 0;
      if (typeof carousel.activeIndex === "number") {
        currentIndex = Math.floor(carousel.activeIndex) % total;
        currentIndex = currentIndex < 0 ? total + currentIndex : currentIndex;
      }

      currentIndex = Number.parseInt(currentIndex, 10);
      if (currentIndex >= 0 && currentIndex < total) {
        carousel.setActiveItem(currentIndex);
      }

      carousel.$el.style.height = "auto";
    },
    initTouchEvent() {
      const carouselContainer = this.$refs.carouselContainer;
      carouselContainer.addEventListener("touchstart", this.handleTouchStart);
      carouselContainer.addEventListener("touchmove", this.handleTouchMove);
      carouselContainer.addEventListener("touchend", this.handleTouchEnd);
    },
    handleTouchStart(e) {
      this.startX = e.changedTouches[0].pageX;
    },
    handleTouchMove() {
      // 可以在这里添加防止误触的逻辑，比如限制滑动方向等
    },
    handleTouchEnd(e) {
      const endX = e.changedTouches[0].pageX;
      const distance = endX - this.startX;
      if (distance > this.minSwipeDistance) {
        this.$refs.carousel.prev();
      } else if (distance < -this.minSwipeDistance) {
        this.$refs.carousel.next();
      }
      this.startX = 0;
    },
    handleScroll(dom) {
      if (this.isLoading || !dom) {
        // 目前正在加载更多
        return;
      }
      const range = 20; // 顶一个可接受的范围，在这个范围内都算达到了底部
      const dec = Math.abs(dom.scrollTop + dom.clientHeight - dom.scrollHeight);
      if (dec <= range) {
        this.fetchMore();
      }
    }, // 加载下一页
    async fetchMore() {
      if (!this.hasMore) {
        // 没有更多啦
        this.isNotMore = true;
        return;
      }
      this.isLoading = true;
      this.page++;

      const resp = await this.fetchData();
      this.datas.records.total = resp.records.total;
      this.datas.records.data = this.datas.records.data.concat(
        resp.records.data
      );

      this.isLoading = false;
    },
    getLinkType(item) {
      return item.link_type === "external" ? "a" : "router-link";
    },

    getLinkProps(item) {
      if (!item.link_url) return;
      const usertoken = this.storage.getItem("usertoken");
      const props = {};

      if (item.link_type === "external") {
        // 外部链接处理逻辑保持不变
        const baseUrl = item.link || item.link_url;
        let href = baseUrl;

        if (usertoken) {
          const separator = baseUrl.includes("?") ? "&" : "?";
          href += `${separator}accesstoken=${encodeURIComponent(usertoken)}`;
        }

        props.href = href;
        // 微信内置浏览器对新窗口支持不稳定，外链统一在当前窗口打开。
        props.target = "_self";
        props.rel = "noopener";
      } else {
        // 处理内部路由（适配 /active/:aid 等路由）
        const link = item.link || item.link_url;

        if (!link) {
          console.warn("内部路由链接为空", item);
          return props;
        }

        // 路由映射表：key为路径前缀，value为{路由名称, 参数名}
        // 新增其他路由时，在此处扩展即可
        const routeMap = {
          active: {
            name: "ActiveDetail", // 对应路由配置中的name
            paramName: "aid", // 对应路由配置中的:aid参数
          },
          // 示例：其他路由可以继续添加
          // 'article': {
          //   name: 'ArticleDetail',
          //   paramName: 'id'
          // }
        };

        // 提取路径前缀（第一个分段）
        const firstSegment = link.split("/")[0];
        const routeConfig = routeMap[firstSegment];

        if (routeConfig) {
          // 匹配到已知路由（如active）
          // 提取参数值（如178）
          const paramValue = link.split("/")[1] || "";

          props.to = {
            name: routeConfig.name,
            params: {
              [routeConfig.paramName]: paramValue, // 动态设置参数名（aid）
            },
          };
        } else {
          // 未匹配到特殊路由，按静态路由处理
          props.to = { name: link };
        }
      }

      return props;
    },
  },
  computed: {
    hasMore() {
      return this.datas.records.data.length < this.datas.records.total;
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/mixin.less";
:deep(.el-carousel__indicators) {
  display: none;
}

.index-container {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
  background-color: #f5f5f5;

  .banner-container {
    width: 100%;
    height: 100vw;
    overflow: hidden;
    position: relative;
    clip-path: url(#bannerCurvedBottom);

    .el-carousel {
      width: 100%;
      height: auto;
    }

    .el-carousel__item {
      width: 100%;
      height: auto;
    }

    // 修复点击区域问题：确保链接组件占满整个轮播项
    .banner-link {
      display: block;
      width: 100%;
      height: 100%;
      cursor: pointer; // 显示手型光标，提示可点击
    }

    .banner-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .image-slot {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background-color: #fff;
      color: #999;
      font-size: 14px;

      &.image-error-slot {
        img {
          width: 100px;
          height: 100px;
          object-fit: contain;
        }
      }
    }

    .el-carousel__indicators {
      bottom: 10px;

      .el-carousel__indicator {
        width: 8px;
        height: 8px;
        margin: 0 4px;
        background-color: rgba(255, 255, 255, 0.5);

        &.is-active {
          width: 24px;
          border-radius: 4px;
          background-color: #fff;
        }
      }
    }
  }

  .index-wrapper {
    position: relative;
    z-index: 10;
    .index-btn-container {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      gap: 10px;
      width: 90%;
      margin: -8vw auto 0;
      padding-bottom: 20px;

      .btn-left-container,
      .btn-right-container {
        flex: 1;
      }

      .btn-right-container {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .btn-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        img {
          width: 100%;
          object-fit: cover;
        }
      }
    }
  }
  .list-container {
    width: 90%;
    margin: auto;
    .list-title {
      .self-flex(flex-start);
    }
  }

  .loading {
    background: transparent;
    margin: 20px 0;
    height: 20px;
  }

  .noMore {
    color: var(--ccc);
    margin: 20px 0;
    height: 20px;
    font-size: 14px;
  }

  .svg-clip-path {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
  }
}
</style>
